// extracted by mini-css-extract-plugin
export var alternate = "_f-h";
export var black = "_f-3";
export var blue = "_f-d";
export var blueLight = "_f-c";
export var brand = "_f-7";
export var error = "_f-9";
export var gray = "_f-6";
export var grayBlue = "_f-b";
export var iconWrapper = "_f-4";
export var indigo = "_f-e";
export var orange = "_f-g";
export var pink = "_f-f";
export var primary = "_f-0";
export var purple = "_f-8";
export var success = "_f-5";
export var warning = "_f-a";
export var white = "_f-1";
export var whiteSuccess = "_f-2";